/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_CommunityInputs */

const en_settings_community = /** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Settings`)
};

const id_settings_community = /** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan Komunitas`)
};

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const es_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const fr_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const de_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const ja_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const zh_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const ar_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const it_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const ru_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const pt_settings_community = en_settings_community;

/** @type {(inputs: Settings_CommunityInputs) => LocalizedString} */
const ko_settings_community = en_settings_community;

/**
* | output |
* | --- |
* | "Community Settings" |
*
* @param {Settings_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_community = /** @type {((inputs?: Settings_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_community(inputs)
	if (locale === "es") return es_settings_community(inputs)
	if (locale === "fr") return fr_settings_community(inputs)
	if (locale === "de") return de_settings_community(inputs)
	if (locale === "ja") return ja_settings_community(inputs)
	if (locale === "zh") return zh_settings_community(inputs)
	if (locale === "ar") return ar_settings_community(inputs)
	if (locale === "id") return id_settings_community(inputs)
	if (locale === "it") return it_settings_community(inputs)
	if (locale === "ru") return ru_settings_community(inputs)
	if (locale === "pt") return pt_settings_community(inputs)
	return ko_settings_community(inputs)
});